import getStore from '../store/store';
import {
  pathnameDashboardMap,
  EventName,
  FeatureName,
  EventType,
  HelpDeskFilterEventNameMap as filterEventMap,
} from './constants';
import { getBrowser } from './utils';
import { sendEventToJumbo } from './jumboClient';
import history from '../history';
import { isPlayGroundMode } from '../utils/CookieToken';
import { toLower } from 'lodash-es';

const getDashboardMode = () => {
  const pathname = window.location.pathname;
  return pathnameDashboardMap[pathname] || '';
};

export const getGlobalTraits = () => {
  const store = getStore(history);
  const state = store.getState();

  const { authState = {}, orderState = {} } = state;

  const traits = {
    user_role: authState.userDetails?.user_role,
    browser: getBrowser(),
    dashboard_mode: getDashboardMode(),
  };
  return traits;
};

export const searchEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  sendEventToJumbo({
    eventName: EventName.SEARCH_EVENT,
    eventProperties: properties,
    traits,
  });
};

export const loadMoreOrdersEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  sendEventToJumbo({
    eventName: EventName.LOAD_MORE_ORDERS,
    eventProperties: properties,
    traits,
  });
};

export const searchFilterChange = (properties = {}) => {
  const traits = getGlobalTraits();
  sendEventToJumbo({
    eventName: EventName.SEARCH_FILTER_CHANGE,
    eventProperties: properties,
    traits,
  });
};

export const popUpOpenendEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  sendEventToJumbo({
    eventName: EventName.POP_UP_OPENEND,
    eventProperties: properties,
    traits,
  });
};

export const popUpClosedEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  sendEventToJumbo({
    eventName: EventName.POP_UP_CLOSED,
    eventProperties: properties,
    traits,
  });
};

export const playGroundModeEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  const isPlayGround = isPlayGroundMode;
  sendEventToJumbo({
    eventName: isPlayGround
      ? EventName.PLAYGROUND_MODE_TURN_OFF
      : EventName.PLAYGROUND_MODE_TURN_ON,
    eventProperties: properties,
    traits,
  });
};

export const helpDeskOpenedEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };
  sendEventToJumbo({
    eventName: EventName.HELP_DESK_OPENED,
    eventProperties: properties,
    traits,
  });
};

export const helpDeskClosedEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };
  sendEventToJumbo({
    eventName: EventName.HELP_DESK_CLOSED,
    eventProperties: properties,
    traits,
  });
};

export const helpNodeShownEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };
  sendEventToJumbo({
    eventName: EventName.HELP_NODE_SHOWN,
    eventProperties: properties,
    traits,
  });
};

export const helpNodeOpenEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };
  sendEventToJumbo({
    eventName: EventName.HELP_NODE_OPENED,
    eventProperties: properties,
    traits,
  });
};

export const helpNodeCloseEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };
  sendEventToJumbo({
    eventName: EventName.HELP_NODE_CLOSED,
    eventProperties: properties,
    traits,
  });
};

export const helpDeskFilterChangeEvent = (properties = {}, filtertype) => {
  const traits = getGlobalTraits();
  filtertype = toLower(filtertype);
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };

  // changed key name for item_name as per jumbo event registry
  if (filtertype === 'items_name') {
    filtertype = 'item_name';
  }
  sendEventToJumbo({
    eventName: EventName[filterEventMap[filtertype]],
    eventProperties: properties,
    traits,
  });
};

export const helpDeskClearFiltersEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };
  sendEventToJumbo({
    eventName: EventName.HELP_DESK_FILTERS_CLEARED,
    eventProperties: properties,
    traits,
  });
};

export const helpDeskHomeClickEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };
  sendEventToJumbo({
    eventName: EventName.HELP_HOME_BUTTON_CLICKED,
    eventProperties: properties,
    traits,
  });
};

export const helpDeskCollapsedEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };
  sendEventToJumbo({
    eventName: EventName.HELP_DESK_COLLAPSED,
    eventProperties: properties,
    traits,
  });
};

export const helpDeskExpandedEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };
  sendEventToJumbo({
    eventName: EventName.HELP_DESK_EXPANDED,
    eventProperties: properties,
    traits,
  });
};

export const helpDeskDraggedEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };
  sendEventToJumbo({
    eventName: EventName.HELP_DESK_DRAGGED,
    eventProperties: properties,
    traits,
  });
};

export const helpNonPrimaryNodeShownEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.HELP,
  };
  sendEventToJumbo({
    eventName: EventName.NON_PRIMARY_HELP_NODE_EXPLORED,
    eventProperties: properties,
    traits,
  });
};

export const invoiceDownloadEvent = (properties = {}) => {
  const traits = getGlobalTraits();
  properties = {
    ...properties,
    event_type: EventType.CLICK,
    feature_name: FeatureName.ITEM_AND_BILLING,
  };
  sendEventToJumbo({
    eventName: EventName.DOWNLOAD_INVOICE,
    eventProperties: properties,
    traits,
  });
};
